import { schema } from 'normalizr';

export const billingAddressSchema = new schema.Entity('billingAddresses', {});

export const contactSchema = new schema.Entity('contacts', {});

export const facilitySchema = new schema.Entity('facilities', {});

export const accountSchema = new schema.Entity('accounts', {
  billingAddresses: [billingAddressSchema],
  contacts: [contactSchema],
  facilities: [facilitySchema],
});
